import { render, staticRenderFns } from "./AILeagueView.vue?vue&type=template&id=4e23b23c&scoped=true&"
import script from "./AILeagueView.vue?vue&type=script&lang=js&"
export * from "./AILeagueView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e23b23c",
  null
  
)

export default component.exports